(function () {
  'use strict';

  function buildSwitcher() {
    const data = [
      { handle: 'dark-fortunes-book',  label: '📖 Paperback', price: '$17.95' },
      { handle: 'dark-fortunes-ebook', label: '📱 eBook',     price: '$4.99'  },
      { handle: 'dark-fortunes-audio', label: '🎧 Audiobook', price: '$19.99' }
    ];

    const currentHandle = window.location.pathname.split('/products/')[1]?.split('?')[0];
    if (!currentHandle) return;
    const isFormatProduct = data.some(d => d.handle === currentHandle);
    if (!isFormatProduct) return;

    // Find the product-details div — this is Horizon's right-hand column
    const productDetails = document.querySelector('.product-details');
    if (!productDetails) return;

    // Build the switcher HTML
    const tabs = data.map(d => {
      const active = d.handle === currentHandle;
      return `<a class="format-switcher__btn${active ? ' is-active' : ''}" href="/products/${d.handle}" aria-current="${active}">`
        + `<span class="format-switcher__btn-label">${d.label}</span>`
        + `<span class="format-switcher__btn-price">${d.price}</span>`
        + `</a>`;
    }).join('');

    const switcher = document.createElement('div');
    switcher.className = 'format-switcher';
    switcher.innerHTML = `<h4 class="format-switcher__label">Choose Format:</h4><div class="format-switcher__tabs" role="group" aria-label="Choose a format">${tabs}</div>`;

    // Insert as the very first child of .product-details
    productDetails.insertBefore(switcher, productDetails.firstChild);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', buildSwitcher);
  } else {
    buildSwitcher();
  }
})();